module.exports = __webpack_public_path__ + "img/no-plc-marker.13e798dc.svg";